import type { RouteObject } from 'react-router-dom';

import { Scopes } from '../../api/types';
import { RouteGuard } from '../../components/RouteGuard';
import { ConfigOverviewPage } from './pages/ConfigOverviewPage';

/** Routes contributed by the Config feature (Phase 5 Wave 4). Tabs driven by `?tab=`. */
export const configRoutes: RouteObject[] = [
  {
    path: 'config',
    element: (
      <RouteGuard scope={Scopes.Admin}>
        <ConfigOverviewPage />
      </RouteGuard>
    ),
  },
];
